/*
 * Created Date: Mon, 26th Jul 2021, 17:31:40 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2021 The Distance
 */

import React from 'react';
import { required, SelectInput, SimpleForm, TextInput } from 'react-admin';
import { adminRoleType } from 'utils/choices';
import { isValidEmail } from 'utils/validation';

const emailValidation = [required(), isValidEmail];

const AdminForm = (props) => {
  return (
    <SimpleForm {...props}>
      <TextInput source="firstName" validate={required()} multiline />
      <TextInput source="lastName" validate={required()} multiline />
      <TextInput source="email" validate={emailValidation} multiline />
      <SelectInput
        source="role"
        choices={adminRoleType}
        validate={required()}
      />
    </SimpleForm>
  );
};

export default AdminForm;
